import { gql } from '@apollo/client';

export const verifyAndUpdateUserGQL = gql`
  mutation verifyAndUpdateUser($input: SetVerifyPoolDto!) {
    verifyAndUpdateUser(input: $input) {
      user {
        _id
        username
        firstName
        lastName
        state
        phone
      }
    }
  }
`;
